import { useEffect, useState } from 'react';

export function useOrientation() {
  const getOrientation = () =>
    window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';

  const [orientation, setOrientation] = useState(getOrientation());

  useEffect(() => {
    const mediaQuery = window.matchMedia('(orientation: portrait)');

    const handler = (e) => {
      setOrientation(e.matches ? 'portrait' : 'landscape');
    };

    // 添加监听器
    mediaQuery.addEventListener('change', handler);

    return () => {
      mediaQuery.removeEventListener('change', handler);
    };
  }, []);

  return orientation;
}
